import { LOGIN_PAGE, USER_WATCHED_OFFERS } from '@constants/routes'
import { NOTICE_MS, notify } from 'lib/notice/notice'
import { currentToken, isWatched, saveWatched } from 'lib/watch/watchStore'

// Kliknięcie serca obserwowania. Gość: zapis w przeglądarce od razu, po dodaniu zachęta do logowania
// (powiadomienia o obniżce ceny), po usunięciu „Cofnij”. t: teksty komunikatów.
export default async function toggleWatch ({ id, type, opener, t }) {
    if (!currentToken()) {
        const on = !isWatched(id)
        const result = await saveWatched({ id, type, on })
        if (result === 'limit') notify(t.limit, { action: { label: t.see, name: t.seeName, href: USER_WATCHED_OFFERS }, opener })
        else if (result) {
            const href = `${LOGIN_PAGE}?powrot=${encodeURIComponent(window.location.pathname + window.location.search)}`
            notify(t.guestAdded, { action: { label: t.loginAction, href, button: true }, opener, stack: true, ms: NOTICE_MS + 2000 })
        } else notify(t.removed, { action: { label: t.undo, onClick: () => saveWatched({ id, type, on: true }) }, opener })
        return
    }
    const result = await saveWatched({ id, type, on: !isWatched(id) })
    if (result === 'limit') notify(t.limit, { action: { label: t.see, name: t.seeName, href: USER_WATCHED_OFFERS }, opener })
    else if (result === null) notify(t.error, { opener })
    else if (result) notify(t.added, { action: { label: t.see, name: t.seeName, href: USER_WATCHED_OFFERS }, opener })
    else notify(t.removed, { opener })
}
